<!-- 分类列表 -->

<template>
  <div class="main" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索分类名称" suffix-icon="el-icon-search" v-model="categoryName"
        :clearable="true" @change="onSearch"></el-input>
      <el-button class="btn" type="primary" @click="handleAdd">新增分类</el-button>
    </div>

    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" row-key="id">
        <el-table-column show-overflow-tooltip min-width="120" prop="categoryName" label="分类名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="sortNum" label="序号"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            <el-button class="btn" type="primary" plain @click="handleEdit(scope.row)">修改</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>

    <!-- 分类弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm">
        <el-row type="flex" justify="space-between">
          <el-col>
            <el-form-item label="一级类目" prop="categoryName">
              <el-input v-model.trim="ruleForm.categoryName" placeholder="请输入类目名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="一级排序" prop="sortNum">
              <el-input-number style="width: 255px;" v-model.trim="ruleForm.sortNum" :min="1"
                placeholder="请输入排序"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      categoryName: "", // 搜索分类
      // 表格数据
      tableData: [],
      // 弹窗
      dialogVisible: false,//弹窗状态
      dialogTitle: "",//弹窗标题
      ruleForm: {
        categoryName: "",
        sortNum: undefined,
      },
      rules: {
        categoryName: [
          {
            required: true,
            message: "请输入一级类目",
            trigger: "blur",
          },
        ],
        sortNum: [
          {
            required: true,
            message: "请输入一级排序",
            trigger: "blur",
          },],
      },
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getCategoryList()
  },
  methods: {
    // 列表
    getCategoryList() {
      this.loading = true
      this.$axios
        .get(this.$api.activityClassList, {
          params: {
            categoryName: this.categoryName || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 新增分类
    handleAdd() {
      this.dialogTitle = "新增分类"
      this.dialogVisible = true
      this.iscategoryNameAdd = true
    },
    // 修改
    handleEdit(row) {
      this.dialogVisible = true
      this.dialogTitle = "修改分类"
      this.$set(this.ruleForm, "categoryName", row.categoryName)
      this.$set(this.ruleForm, "sortNum", row.sortNum)
      this.$set(this.ruleForm, "id", row.id)
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false
      this.dialogTitle = ""
      this.resetForm()
      this.ruleForm = {}
    },
    // 表单校验
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let api;
          let obj = Object.assign({}, this.ruleForm)
          if (this.ruleForm.id) {
            api = this.$api.updateActivityClass
          } else {
            api = this.$api.addActivityClass
          }
          this.$axios
            .post(api, obj)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(`${this.$route.query.id ? "修改" : "新增"}成功`)
                this.dialogVisible = false
                this.getCategoryList()
              }
            })
            .catch(err => {
              this.btnLoading = false
              this.$message.error(err.desc)
            })
        }
      })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否要删除该分类?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(`${this.$api.deleteActivityClass}/${row.id}`)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.onSearch()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    // 默认弹窗设置重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getCategoryList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getCategoryList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getCategoryList()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {

  ::v-deep .el-input-number__decrease {
    border-radius: 10px 0 0 10px;
  }

  ::v-deep .el-input-number__increase {
    border-radius: 0 10px 10px 0;
  }
}
</style>
